/** DOM event when a client's order status changes (socket push). */
export const CLIENT_ORDERS_UPDATED_EVENT = 'catalogofworks:client-orders-updated';

export type ClientOrdersUpdatedDetail = {
  orderId: string;
  status: string;
  tenantId?: string;
};

export function dispatchClientOrdersUpdated(detail: ClientOrdersUpdatedDetail): void {
  window.dispatchEvent(new CustomEvent(CLIENT_ORDERS_UPDATED_EVENT, { detail }));
}
